const errors = {
  generic: 'Ocorreu um erro inesperado',
  title: 'Erro',
  notFound: {
    title: 'Página não encontrada',
    description:
      'Não encontramos o que você está procurando. O endereço pode ter sido alterado ou a página não existe mais no nosso sistema.',
    action: 'Voltar ao início',
  },
  generic_page: {
    title: 'Algo deu errado',
    description:
      'Encontramos um erro inesperado. Por favor, tente recarregar a página ou entre em contato com o suporte.',
    action: 'Recarregar página',
    code: 'Erro',
  },
  session: {
    expired: 'Sessão expirada. Entre novamente.',
  },
  profile: {
    updateErrorTitle: 'Não foi possível atualizar o perfil',
    updateErrorDescription: 'Erro ao atualizar perfil.',
    pictureErrorTitle: 'Não foi possível atualizar a foto',
    pictureErrorDescription: 'Erro ao atualizar foto.',
    passwordErrorTitle: 'Não foi possível alterar a senha',
    passwordErrorDescription: 'Erro ao alterar senha.',
  },
} as const
export default errors
